<template lang="html">
  <svg id="menu-toggle-image"
    data-name="menu-toggle-image"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 23">
    <title>Untitled-1</title>
    <rect width="30" height="3" rx="1.5"/>
    <rect y="9" width="26" height="3" rx="1.5"/>
    <rect y="18" width="18" height="3" rx="1.5"/>
  </svg>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
  #menu-toggle-image {
    fill: #3a62cc;
    width: 32px;
    height: auto;
  }
</style>
